import type { PrimaryToolbarPluginOptions } from '@atlaskit/editor-plugin-primary-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';

interface Props {
	options: {
		contextualFormattingEnabled: boolean;
	};
}

export function primaryToolbarPluginOptions({ options }: Props): PrimaryToolbarPluginOptions {
	return {
		contextualFormattingEnabled: fg('platform_hide_contextual_toolbar_for_embedded_page')
			? options.contextualFormattingEnabled
			: true,
	};
}
4;
